import { useRef } from "react";

import useIframeHeightReset from "../hooks/useIframeHeightReset";

const Inline = ({ iframeURL, customization }) => {
  const { dynamicHeight } = customization;

  const iframeRef = useRef(null);
  useIframeHeightReset(iframeRef, dynamicHeight);

  return <iframe className="m-auto border-0" ref={iframeRef} src={iframeURL} />;
};

export default Inline;
